import { Palette } from '@mui/icons-material';
import { Box, FormControl, FormLabel, Input, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { makeStyles } from '@mui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/pickerStyle.js';
import Button from 'components/CustomButtons/Button.js';
import CustomInput from 'components/CustomInput/CustomInput.js';

const useStyles = makeStyles(styles);

const ColorPicker = ({ selectedColor, label = '', onChange = null }) => {
  const classes = useStyles();
  const [hexValue, setHexValue] = useState(selectedColor ?? '#000000');
  const [color, setColor] = useState(selectedColor ?? '#000000');
  const [colorError, setColorError] = useState(false);
  const [inputValue, setInputValue] = useState(
    hexValue.startsWith('#') ? hexValue.slice(1) : hexValue
  );

  useEffect(() => {
    if (selectedColor && color !== selectedColor) {
      setColor(selectedColor);
      setHexValue(selectedColor);
    }
  }, [selectedColor]);

  const handleSelect = (e) => {
    setHexValue(e.target.value);
    if (/^#([0-9A-Fa-f]{6})$/g.test(e.target.value)) {
      setColorError(false);
      setColor(e.target.value);
      if (onChange) onChange(e.target.value);
    } else {
      setColorError(true);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/[^0-9A-Fa-f]/g, ''); // Allow only hex characters
    setInputValue(value);
    handleSelect({ target: { value: `#${value}` } });
  };

  return (
    <Box className={classes.formControl}>
      <FormLabel className={classes.colorPickerLabel}>
        <p
          style={{ marginBottom: 0 }}
          dangerouslySetInnerHTML={{ __html: label }}
        ></p>
      </FormLabel>
      <Box>
        <FormControl variant='standard'>
          <Box className={classes.pickerContainer}>
            <Box
              sx={{
                ...styles.colorPickerBox,
                ...{ backgroundColor: `${color}`, borderColor: `${color}` },
              }}
            />
            <Input
              type='color'
              value={color}
              onChange={(e) => {
                handleInputChange(e);
              }}
              className={classes.colorPickerInput}
            />
            <Button
              className={classes.colorPickerButton}
              size='sm'
              color='rose'
              justIcon={true}
            >
              <Palette />
            </Button>
          </Box>
        </FormControl>
        <FormControl>
          <Box className={classes.inputContainer}>
            <Typography variant='body1' className={classes.hashSymbol}>
              #
            </Typography>
            <CustomInput
              type='text'
              value={inputValue}
              inputProps={{
                value: inputValue,
                className: classes.hexInput,
                style: {
                  marginTop: -15,
                },
                onChange: handleInputChange,
                error: colorError,
              }}
            />
          </Box>
        </FormControl>
      </Box>
      {colorError && (
        <Typography variant='caption' color='error'>
          Field must contain 6 alphanumeric characters
        </Typography>
      )}
    </Box>
  );
};

export default ColorPicker;
